import type { ParametroOtorgante } from '../types';

/** Aplica los colores del otorgante como CSS custom properties en :root. */
export function applyTheme(params: ParametroOtorgante[]): void {
  const set = (prop: string, key: string) => {
    const found = params.find((p) => p.idCampo === key);
    if (found?.valor) document.documentElement.style.setProperty(prop, found.valor);
  };
  set('--color-primary',   'COLOR_PRIMARIO');
  set('--color-secondary', 'COLOR_SECUNDARIO');
  set('--color-accent',    'COLOR_ACENTUACION');
  set('--color-text',      'COLOR_DE_TEXTO');
}

/** Devuelve el valor de un parámetro por su idCampo, con fallback opcional. */
export function getParam(
  params: ParametroOtorgante[],
  key: string,
  fallback = '',
): string {
  return params.find((p) => p.idCampo === key)?.valor ?? fallback;
}
